{/* Copyright 2026 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. */}

import {Layout} from '../../../src/Layout';
export default Layout;
import {FunctionAPIGroup} from '../../../src/FunctionAPI';
import {InterfaceType} from '../../../src/types';
import docs from 'docs:@react-aria/select';
import statelyDocs from 'docs:@react-stately/select';

export const section = 'Hooks';
export const description = 'Provides the behavior and accessibility implementation for a select component.';
export const isSubpage = true;

# useSelect

<PageDescription>{docs.exports.useSelect.description}</PageDescription>

```tsx render files={["starters/hooks/src/Select.tsx", "starters/hooks/src/DropdownListBox.tsx", "starters/hooks/src/Select.css", "starters/hooks/src/Button.css", "starters/hooks/src/Form.css", "starters/hooks/src/ListBox.css", "starters/hooks/src/Popover.css"]}
"use client";
import {Select, SelectItem} from 'hooks-starter/Select';

<Select label="Favorite Animal">
  <SelectItem>Aardvark</SelectItem>
  <SelectItem>Cat</SelectItem>
  <SelectItem>Dog</SelectItem>
  <SelectItem>Kangaroo</SelectItem>
  <SelectItem>Panda</SelectItem>
  <SelectItem>Snake</SelectItem>
</Select>
```

## API

<FunctionAPIGroup
  functions={[
    {function: statelyDocs.exports.useSelectState, links: statelyDocs.links},
    {function: docs.exports.useSelect, links: docs.links},
  ]}
/>

### SelectState

<InterfaceType {...statelyDocs.exports.SelectState} links={statelyDocs.links} />

### AriaSelectOptions

<InterfaceType {...docs.exports.AriaSelectOptions} />

### SelectAria

<InterfaceType {...docs.exports.SelectAria} />
